import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GovernmentIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                "clip-path": "url(#clip0_26_455)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M17.0508 11.3542H1.10132L9.07607 6.79724L17.0508 11.3542Z",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.10132 17.0505H17.0508",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M2.24072 11.3542V17.0505",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.6582 11.3542V17.0505",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.07593 11.3542V17.0505",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.4937 11.3542V17.0505",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.9116 11.3542V17.0505",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.51904 9.38114V7.36682C4.51904 4.85006 6.55928 2.80981 9.07604 2.80981C11.5928 2.80981 13.633 4.85006 13.633 7.36682V9.38114",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.07617 2.80986V1.10098",
                        stroke: "#676879",
                        "stroke-width": "1.25",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_26_455",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
